import { cn } from '@heroui/react';

/**
 * The NN mark.
 *
 * A raster, not an SVG: the artwork is a rendered image with a gradient
 * background and metallic detail, and there is no vector source. Served from
 * `public/` at 64px so a 32px slot still has a 2x asset.
 *
 * `alt=""` by default because every current caller sits inside something that
 * already carries the name — the header cell has an `aria-label`, the login
 * card has a heading. A decorative image announced next to its own label reads
 * the name twice.
 */
export function Logo({ className, alt = '' }: { className?: string; alt?: string }) {
  return <img src="/logo-64.png" alt={alt} className={cn('object-cover', className)} />;
}
